import { useTranslation } from "react-i18next";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";

import Typography from "features/components/Typography";

const SafeModeLabel = () => {
  const { t } = useTranslation();

  return (
    <Typography
      variant="caption"
      className="flex items-center gap-1 mb-1 !text-gray-500"
      data-testid="duck-safe-mode-label"
    >
      <ShieldOutlinedIcon sx={{ fontSize: 14 }} />
      {t("duck:safe_mode")}
    </Typography>
  );
};

export default SafeModeLabel;
